var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 11.703 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 11.703,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M2.163,18a2.09,2.09,0,0,1-1.526-.633A2.069,2.069,0,0,1,0,15.845,2.022,2.022,0,0,1,.633,14.34a2.1,2.1,0,0,1,1.522-.617,2.055,2.055,0,0,1,1.506.612,2.035,2.035,0,0,1,.617,1.5,2.125,2.125,0,0,1-.612,1.526,2,2,0,0,1-1.5.637m7.409,0a2.154,2.154,0,0,1-2.146-2.155,2.028,2.028,0,0,1,.629-1.506,2.17,2.17,0,0,1,3.026,0,2.026,2.026,0,0,1,.622,1.5,2.11,2.11,0,0,1-.621,1.526A2.03,2.03,0,0,1,9.572,18M2.163,11.125A2.1,2.1,0,0,1,.637,10.5,2.046,2.046,0,0,1,0,8.986,2,2,0,0,1,.633,7.478a2.126,2.126,0,0,1,1.522-.6A2.067,2.067,0,0,1,3.66,7.48a2.017,2.017,0,0,1,.617,1.5,2.1,2.1,0,0,1-.612,1.52,2.014,2.014,0,0,1-1.5.629m7.409,0a2.146,2.146,0,0,1-2.146-2.14,2,2,0,0,1,.629-1.508,2.2,2.2,0,0,1,3.026,0,2.007,2.007,0,0,1,.622,1.5,2.083,2.083,0,0,1-.621,1.52,2.042,2.042,0,0,1-1.51.629M2.163,4.277A2.1,2.1,0,0,1,.637,3.648,2.046,2.046,0,0,1,0,2.137,2.045,2.045,0,0,1,.633.622,2.094,2.094,0,0,1,2.155,0,2.04,2.04,0,0,1,3.66.621a2.063,2.063,0,0,1,.617,1.51,2.1,2.1,0,0,1-.612,1.518,2.015,2.015,0,0,1-1.5.629m7.409,0a2.068,2.068,0,0,1-1.518-.629,2.059,2.059,0,0,1-.629-1.511A2.051,2.051,0,0,1,8.054.622a2.153,2.153,0,0,1,3.026,0,2.054,2.054,0,0,1,.622,1.51,2.081,2.081,0,0,1-.621,1.518,2.042,2.042,0,0,1-1.51.629",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.6af869b52d7e9a6bd1592463347a6d79.svg";
export { ForwardRef as ReactComponent };